import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { map, catchError, delay } from 'rxjs/operators';
import { HttpErrorResponse, HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Globals } from '../_globals';


@Injectable()
export class StripeService {


    constructor(
        private http: HttpClient,
        public globals: Globals
    ) { }





    public getStripeAccountForStore(id) {

        return this.http.get(environment.apiUrl + 'api/ext-stripe/account/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }




    public removeStripeFromStore(id) {

        const data = {
            paymentConfigId: id
        }

        console.log(data);

        return this.http.request('delete', environment.apiUrl + 'api/ext-payment-config/unlink-stripe', { body: data } )
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }





    // HANDLE DATA & ERRORS FUNCTIONS


    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }


    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/stripe.service.ts